import { createGenericApiSlice } from '../../../Api/Factory/genericApiFactory';
import { TagTypes } from '../../../Api/Types/tagTypes';
import { OfferOptionsMapping } from '../Types/offerOptionsMappingsTypes';

export const offerOptionsMappingsApi = createGenericApiSlice<OfferOptionsMapping>({
  reducerPath: 'offerOptionsMappingsApi',
  tag: TagTypes.OfferOptionsMapping,
  endpoint: 'offer-options-mapping',
});

export const {
  useGetAllQuery: useGetOfferOptionsMappingsQuery,
  useGetByIdQuery: useGetOfferOptionsMappingByIdQuery,
  useCreateMutation: useCreateOfferOptionsMappingMutation,
  useUpdateMutation: useUpdateOfferOptionsMappingMutation,
  useDeleteMutation: useDeleteOfferOptionsMappingMutation,
} = offerOptionsMappingsApi;
